import * as actionTypes from "../types";
const initialState = {
    refresh: true

}

const pageRefresh = ( state = initialState,action ) => {
    switch (action.type) {
        case actionTypes.SET_PAGE_REFRESH:
          return {
            ...state,
            refresh: action.payload,
          };
          default:
            return state;
}
}

export default pageRefresh